module.exports = __webpack_public_path__ + "static/beach_background-22541376dcde45b53a24bffd6ca7ef46.jpg";